import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

export const ajaxGet = async function(url, withCredentials) {
	try {
		const response = await axios({
			method: 'get',
			url: url,
			withCredentials: withCredentials || false
		})
		return response.data
	} catch (error) {
		console.error(error)
	}
}

export const ajaxPost = async function(url, data, withCredentials) {
	try {
		const response = await axios({
			method: 'post',
			data: data,
			url: url,
			withCredentials: withCredentials || false
		})
		return response.data
	} catch (error) {
		console.error(error)
	}
}
